class EditCodes {
	static Invalid = 0;
	static EtmFill = 1;
	static BlockFill = 2;
	static EmergencyPlaylist = 3;
	static ManualSkip = 4;
	static ManualInsert = 5;
	static ManualEdit = 6;
	static ManualReorder = 7;
}

export default EditCodes;